import { useSelector } from "react-redux";
import { Button } from "antd";
import CardPage from "../../../layout/CardPage";
import TablaSolicitudes from "../tabla/TablaSolicitudes";
import { useAtencionFilters } from "../../../hooks/useAtencionFilters";

export const ListaSolicitudes = ({ onOpenChat, filteredData, loading, filtros, limpiarFiltros }) => {
  const { solicitudes } = useSelector((state) => state.atencionReducer);

  // hook de filtros (solo para funciones auxiliares)
  const {
    filterInfo,
    isFiltered,
    tableRef,
    handleTableChange
  } = useAtencionFilters();

  return (
    <CardPage titulo={`Solicitudes ${filteredData.length}${filteredData.length !== solicitudes.length ? ` de ${solicitudes.length}` : ''}`}>
      {/* banner de filtros activos */}
      {isFiltered && filterInfo.label && (
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16, 
          padding: '8px 16px',
          backgroundColor: '#fff2e8',
          borderRadius: '8px',
          border: '1px solid #ffb366'
        }}>
          <span style={{ 
            color: '#d46b08',
            fontSize: '14px',
            marginRight: '12px'
          }}>
            Mostrando: {filterInfo.label} ({filterInfo.count} solicitudes)
          </span>
          <Button
            size="small"
            type="text"
            onClick={limpiarFiltros}
            style={{ 
              color: '#ff4d4f',
              fontSize: '12px',
              borderRadius: '6px'
            }}
          >
            Limpiar filtros
          </Button>
        </div>
      )}

      {/* tabla con filtros de columnas */}
      <TablaSolicitudes
        ref={tableRef}
        dataSource={filteredData}
        originalDataSource={solicitudes}
        loading={loading}
        onOpenChat={onOpenChat}
        onTableChange={handleTableChange}
      />
    </CardPage>
  );
};